// FROM -  ?rest_route=/rapi/dynamic-qr-code&qr=Wanderlust+Yoke+Top+Pattern+QR+Code
// TO - ?qr=Wanderlust+Yoke+Top+Pattern+QR+Code&rest_route=%2Frapi%2Fdynamic-qr-code
// TO - https://delivery.shopifyapps.com/-/08b78895e5565c66/fb2ce781211387ac
// restructure url 


function redirect() {
    if (window.location.search.includes('?rest_route')) {
        var original_url = window.location.search;
        var productTitle = original_url.split('qr=')[1];

        var new_url_structure = `?qr=${productTitle}&rest_route=%2Frapi%2Fdynamic-qr-code`;
        if (productTitle == undefined || !productTitle) {
            console.log('no pattern');
        } else {
            window.location.replace(window.location.origin + `/qr${new_url_structure}`);
        }
    } else {
        return;
    }
}
setTimeout(
    redirect(), 1000
);

function qrUrl() {
    if ((window.location.search.includes('?qa')) && (!window.location.search.includes('/qa'))) {
        window.location.replace(window.location.origin + `/qr${window.location.search}`)
    } else {
        return;
    }
}
setTimeout(qrUrl(), 1000);